import React from 'react';
import styles from './SubLinks.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Link from 'next/link';
type subRoutesType = {
  text: string;
  link: string;
  target?: string;
  rel?: string;
}[];
const subRoutes: subRoutesType = [{
  text: 'تماس با ما',
  link: '/support'
}, {
  text: 'درباره شب',
  link: '/about'
}, {
  text: 'سوالات متداول',
  link: '/faq',
  target: '_blank',
  rel: 'noreferrer'
}, {
  text: 'حقوق کاربران',
  link: '/terms'
}, {
  text: 'قوانین استفاده از شب',
  link: '/policies'
}, {
  text: 'قواعد باز پرداخت وجه',
  link: '/refund'
}, {
  text: 'کد تخفیف شب',
  link: '/landing/discount'
}, {
  text: 'وبلاگ شب',
  target: '_blank',
  rel: 'noreferrer',
  link: 'https://blog.shab.ir/?_ga=2.209945429.1525541813.1631430367-896746444.1625133755'
}, {
  text: 'نحوه کار شب',
  link: '/help/trust'
}, {
  text: 'همکاری سازمانی',
  link: '/landing/b2b'
}, {
  text: 'فرصت های شغلی',
  link: '/careers'
}];
const SubLinks = () => {
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="SubLinks" data-sentry-source-file="SubLinks.tsx">
      <Typography component={'h5'} variant={'title'} data-sentry-element="Typography" data-sentry-source-file="SubLinks.tsx">
        با شب بیشتر آشنا شوید
      </Typography>
      <Box component={'ul'} className={styles['links-container']} data-sentry-element="Box" data-sentry-source-file="SubLinks.tsx">
        {subRoutes.map((item, index) => {
        const {
          text,
          link,
          ...rest
        } = item;
        return <Box component={'li'} key={'SUB_ROUTE_ITEM' + index}>
              <Link href={link} {...rest} className={styles['links-item']}>
                {text}
              </Link>
            </Box>;
      })}
      </Box>
    </Box>;
};
export default SubLinks;